/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_SubjectInputs */

const en_field_subject = /** @type {(inputs: Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject Matter`)
};

const es_field_subject = /** @type {(inputs: Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sujeto / Tema`)
};

const fr_field_subject = /** @type {(inputs: Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sujet`)
};

const de_field_subject = /** @type {(inputs: Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motiv`)
};

const ja_field_subject = /** @type {(inputs: Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主題`)
};

const zh_field_subject = /** @type {(inputs: Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主题`)
};

const ar_field_subject = /** @type {(inputs: Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الموضوع`)
};

const id_field_subject = /** @type {(inputs: Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subjek Perkara`)
};

const it_field_subject = /** @type {(inputs: Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soggetto`)
};

const ru_field_subject = /** @type {(inputs: Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предмет/Тема`)
};

const pt_field_subject = /** @type {(inputs: Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sujeito/Tema`)
};

const ko_field_subject = /** @type {(inputs: Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주제`)
};

/**
* | output |
* | --- |
* | "Subject Matter" |
*
* @param {Field_SubjectInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_subject = /** @type {((inputs?: Field_SubjectInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_SubjectInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_subject(inputs)
	if (locale === "es") return es_field_subject(inputs)
	if (locale === "fr") return fr_field_subject(inputs)
	if (locale === "de") return de_field_subject(inputs)
	if (locale === "ja") return ja_field_subject(inputs)
	if (locale === "zh") return zh_field_subject(inputs)
	if (locale === "ar") return ar_field_subject(inputs)
	if (locale === "id") return id_field_subject(inputs)
	if (locale === "it") return it_field_subject(inputs)
	if (locale === "ru") return ru_field_subject(inputs)
	if (locale === "pt") return pt_field_subject(inputs)
	return ko_field_subject(inputs)
});